const numberFormatter = new Intl.NumberFormat('ru-RU', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

/** Numbers are formatted as in legacy `lib/format-number`; any other value is returned as is. */
export const formatNumber = (value: unknown): string =>
  typeof value === 'number' ? numberFormatter.format(value) : String(value ?? '');
